import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from '../../service/authentication.service';
import { LoginStateService } from "./login-state.service";
import { DomSanitizer } from "@angular/platform-browser";
import { MatIcon, MatIconRegistry } from '@angular/material/icon';
import { User } from '../../_model/user/user';
import { takeUntil } from 'rxjs/operators';
import { fromEvent, Subject } from 'rxjs';
import { MatCard, MatCardContent, MatCardHeader, MatCardTitle } from '@angular/material/card';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';


const googleLogoURL = "data:image/svg+xml;charset=utf-8,%3Csvg%20enable-background%3D'new%200%200%20533.5%20544.3'%20version%3D'1.1'%20viewBox%3D'0%200%20533.5%20544.3'%20xml%3Aspace%3D'preserve'%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20xmlns%3Acc%3D'http%3A%2F%2Fcreativecommons.org%2Fns%23'%20xmlns%3Adc%3D'http%3A%2F%2Fpurl.org%2Fdc%2Felements%2F1.1%2F'%20xmlns%3Ans%3D'%26amp%3Bns_sfw%3B'%20xmlns%3Ardf%3D'http%3A%2F%2Fwww.w3.org%2F1999%2F02%2F22-rdf-syntax-ns%23'%3E%20%3Cpath%20d%3D'm533.5%20278.4c0-18.5-1.5-37.1-4.7-55.3h-256.7v104.8h147c-6.1%2033.8-25.7%2063.7-54.4%2082.7v68h87.7c51.5-47.4%2081.1-117.4%2081.1-200.2z'%20style%3D'fill%3A%234285f4'/%3E%20%3Cpath%20d%3D'm272.1%20544.3c73.4%200%20135.3-24.1%20180.4-65.7l-87.7-68c-24.4%2016.6-55.9%2026-92.6%2026-71%200-131.2-47.9-152.8-112.3h-90.5v70.1c46.2%2091.9%20140.3%20149.9%20243.2%20149.9z'%20style%3D'fill%3A%2334a853'/%3E%20%3Cpath%20d%3D'M119.3%2C324.3c-11.4-33.8-11.4-70.4%2C0-104.2V150H28.9c-38.6%2C76.9-38.6%2C167.5%2C0%20244.4L119.3%2C324.3z'%20style%3D'fill%3A%23fbbc04'/%3E%20%3Cpath%20d%3D'm272.1%20107.7c38.8-0.6%2076.3%2014%20104.4%2040.8l77.7-77.7c-49.2-46.2-114.5-71.6-182.1-70.8-102.9%200-197%2058-243.2%20150l90.4%2070.1c21.5-64.5%2081.8-112.4%20152.8-112.4z'%20style%3D'fill%3A%23ea4335'/%3E%3C%2Fsvg%3E";

@Component({
  templateUrl: './login.component.html',
  standalone: true,
  imports: [
    MatCardContent,
    MatIcon,
    MatCard,
    MatCardHeader,
    MatCardTitle,
    MatProgressSpinnerModule
],
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit, OnDestroy {
  returnUrl!: string;
  isLoggingIn = false;
  private ngUnsubscribe = new Subject<void>();
  private readonly LOGGED_IN_KEY = 'isLoggedIn';

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authenticationService: AuthenticationService,
    private loginStateService: LoginStateService,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer){
      this.matIconRegistry.addSvgIcon(
        "logo",
        this.domSanitizer.bypassSecurityTrustResourceUrl(googleLogoURL)
        );
        
  const returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
  this.authenticationService.setReturnUrl(returnUrl);

    }
    
    ngOnInit() {
      this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';

          // Check if already logged in (in this tab)
    if (this.authenticationService.isLoggedIn()) {
      this.router.navigate([this.returnUrl]);
    }
        // Listen for login events from other tabs (using localStorage)
        //method1
        window.addEventListener('storage', (event) => {
          if (event.storageArea == localStorage && event.key === this.LOGGED_IN_KEY && event.newValue === 'true') {
            this.router.navigate([this.returnUrl]);
          }
        });
    //method2
        fromEvent<MessageEvent>(new BroadcastChannel('login'), 'message')
          .pipe(takeUntil(this.ngUnsubscribe))
          .subscribe((event: MessageEvent) => {
            if (event.data === 'loggedIn' && this.router.url.includes('/login')) {
              this.router.navigate([this.returnUrl]);
            }
          });
    }
  onSignIn() {
    
    this.authenticationService.login();
    this.isLoggingIn = true;
    const user = {} as User;
    this.loginStateService.userInfoData$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(res => {
        if (res) {
          user.name = res.name;
          user.imageUrl = res.picture;
        }
      });

      this.loginStateService.loginData$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(response => {
      if (response) {
        user.email = response.email;
        user.clientId = response.clientId;
        user.fmSystemId = response.fmSystemListId;
        user.token = response.token;
        user.brand = response.brand;
        sessionStorage.setItem('currentUser', JSON.stringify(user));
        localStorage.setItem('currentUser', JSON.stringify(user));
        localStorage.setItem(this.LOGGED_IN_KEY, 'true'); // Use the dedicated key
        new BroadcastChannel('login').postMessage('loggedIn'); // Notify other tabs

        const currentUser = JSON.parse(sessionStorage.getItem('currentUser')?? '{}');
        if (currentUser && currentUser.token) {
          this.router.navigate([this.returnUrl]);  
          this.authenticationService.returnUrl.next(this.returnUrl);
        }
        this.loginStateService.loginStateChanged(true);
        this.isLoggingIn = false;
      }
      (error:any) => {
        this.authenticationService.logout();
        console.error('Error: Unable to authenticate user. ' +
          'Please check that you are authorised for this application; ' + error.toString());
        this.isLoggingIn = false;
      }
    }) 
    this.getLoader();

  };

getLoader(){
  this.authenticationService.loaderVal$
  .pipe(takeUntil(this.ngUnsubscribe))
  .subscribe(response => {
    this.isLoggingIn = false;
  });
}
ngOnDestroy(): void {
  this.ngUnsubscribe.next();
  this.ngUnsubscribe.complete();
}

}



  

